import type { JobPriorityType, JobType } from '@/enum'
import type {
  IAssignedEmployee,
  IJobAssociatedAsset,
  IJobAssociatedMaintenanceType,
  IJobAssociatedTaskSheet,
  IJobSchedule,
  IJobScheduleOptions,
  INextTriggerInfo,
  IUser,
  IVendor
} from '@/interfaces'
import type { IDocument } from '@/interfaces/IDocument'
import NextTriggerInfo from './NextTriggerInfo'
import Base from '../Base'
import DocumentModel from '../DocumentModel'
import User from '../users/User'
import { Vendor } from '../vendors'
import JobAssociatedAsset from './JobAssociatedAsset'
import JobAssociatedMaintenanceType from './JobAssociatedMaintenanceType'
import JobAssociatedTaskSheet from './JobAssociatedTaskSheet'
import JobScheduleOptions from './JobScheduleOptions'
import AssignedEmployee from '../employees/AssignedEmployee'

class JobSchedule extends Base implements IJobSchedule {
  title: string

  description?: string

  jobType: JobType

  priority: JobPriorityType

  asset: IJobAssociatedAsset

  maintenanceTypes?: IJobAssociatedMaintenanceType[]

  options: IJobScheduleOptions

  assignedEmployees: IAssignedEmployee[]

  assignedEmployeeIds: string[]

  workOrderVendor?: IVendor

  workOrderVendorId?: string

  taskSheets: IJobAssociatedTaskSheet[]

  documents: IDocument[]

  nextTriggerInfo?: INextTriggerInfo

  constructor(schedule: any) {
    super(schedule)
    this.title = schedule?.title
    this.description = schedule?.description
    this.jobType = schedule?.jobType
    this.priority = schedule?.priority
    this.asset = new JobAssociatedAsset(schedule?.asset)
    this.maintenanceTypes =
      schedule?.maintenanceTypes?.map(
        (maintenanceType: any) => new JobAssociatedMaintenanceType(maintenanceType)
      ) ?? []
    this.options = new JobScheduleOptions(schedule?.options)
    this.assignedEmployees = schedule?.assignedEmployees.map(
      (assignedEmployee: any) => new AssignedEmployee(assignedEmployee)
    )
    this.assignedEmployeeIds = schedule?.assignedEmployees.map(
      (assignedEmployee: any) => assignedEmployee.employeeId
    )
    this.workOrderVendor = new Vendor(schedule?.workOrderVendor)
    this.workOrderVendorId = schedule?.workOrderVendorId
    this.taskSheets =
      schedule?.taskSheets.map((taskSheet: any) => new JobAssociatedTaskSheet(taskSheet)) ?? []
    this.documents = schedule?.documents.map((document: any) => new DocumentModel(document)) ?? []
    if (schedule?.nextTriggerInfo) {
      this.nextTriggerInfo = new NextTriggerInfo(schedule.nextTriggerInfo)
    }
  }
}

export default JobSchedule
